// CAKE (§13.4): C major, 138.5 BPM, polka-pop. Tuba oom on 1 and 3 (root, then fifth, with
// walk-ups into new phrases), accordion pah on 2 and 4, a bouncing glockenspiel tune, an
// off-beat tambourine and a tight polka kit. A: I–IV–V7–I then the II7 (V/V) lift; B: IV and its
// borrowed minor iv, vi–ii–V7 home.
import type { SongDef } from '../songTypes';

export const CAKE: SongDef = {
  id: 'cake',
  rootMidi: 60,
  scale: 'major',
  swing: 0,
  bars: 16,
  chords: [
    'I', 'IV', 'V7', 'I', 'I', 'V7/V', 'V7', 'I',
    'IV', 'iv', 'I', 'vi', 'ii7', 'V7', 'I', 'V7',
  ],
  drums: { kick: 'x.......x.......', snare: '....x.......x...', hat: 'x.x.x.x.x.x.x.xx', perc: '..x...x...x...x.' },
  drumsB: { kick: 'x.......x.....x.', snare: '....x.......x...', hat: 'x.x.x.x.x.x.x.xx', perc: '..x...x...x...x.' },
  fill: { kick: 'x.......x.......', snare: '....x...x.x.xxXX', hat: 'x.x.x.x.x.......', perc: '................' },
  pickup: { kick: 'x.......x.......', snare: '....x...x.x.xxXX', hat: 'x.x.x.x.x.x.x.x.' },
  bass: [
    'C2 - . . . . . . G1 - . . . . . .',
    'F1 - . . . . . . C2 - . . . . . .',
    'G1 - . . . . . . D2 - . . . . . .',
    'C2 - . . . . . . G1 - . . . . . .',
    'C2 - . . . . . . E2 - . . . . . .',
    'D2 - . . . . . . A1 - . . . . F#1 -',
    'G1 - . . . . . . D2 - . . . . B1 -',
    'C2 - . . . . . . G1 - . . D2 - E2 -',
    'F2 - . . . . . . C2 - . . . . . .',
    'F2 - . . . . . . C2 - . . . . . .',
    'C2 - . . . . . . G1 - . . . . . .',
    'A1 - . . . . . . E2 - . . . . . .',
    'D2 - . . . . . . A1 - . . . . . .',
    'G1 - . . . . . . D2 - . . . . B1 -',
    'C2 - . . . . . . G1 - . . . . . .',
    'G1 - . . . . . . D2 - . . B1 - . .',
  ],
  lead: [
    'G5 - E5 - G5 - E5 - C6 - - - G5 - - -',
    'A5 - F5 - A5 - F5 - C6 - - - A5 - - -',
    'G5 - B5 - D6 - - - F5 - - - D5 - - -',
    'E5 - - - C5 - - - . . E5 - G5 - - -',
    'C6 - B5 - C6 - G5 - E5 - - - G5 - - -',
    'F#5 - A5 - D6 - - - C6 - - - A5 - - -',
    'B5 - - - A5 - G5 - F5 - - - D5 - - -',
    'C5 - - - E5 - - - C5 - . . . . . .',
    'A5 - - - C6 - - - F6 - - - C6 - - -',
    'Ab5 - - - C6 - - - F6 - - - C6 - - -',
    'G5 - - - E5 - - - C6 - - - G5 - - -',
    'A5 - - - E5 - - - C6 - - - A5 - - -',
    'F5 - A5 - D6 - - - C6 - A5 - F5 - - -',
    'G5 - B5 - D6 - - - F6 - - - D6 - - -',
    'E6 - - - D6 - - - C6 - - - G5 - - -',
    'B5 - - - D6 - - - G5 - - - . . . .',
  ],
  arp: '1 . 3 . 5 . 8 . 5 . 3 . 5 . 8 .',
  comp: '....x-......x-..',
  compB: '....x-......x-x-',
  voicing: 'triad',
  chordRange: [60, 76],
  instruments: { bass: 'tuba', chords: 'accordion', lead: 'glock', arp: 'marimba', perc: 'tambourine' },
  kit: { kick: 'kickPolka', snare: 'snarePolka', hat: 'hat', crash: 'crash' },
  stabs: 'X.......x.......',
  mix: { hat: -6, perc: -5, arp: -8, lead: -2, bass: -3 },
  level: 3.5,
};
